import {
    ProductDetailTabSection,
    ProductDetailTabTable,
    ProductDetailTabMetrics,
    emptyProductDetailColumns,
    type ProductDetailTabProps
} from "@/views/pages/productManagement/ProductDetailTabPrimitives";

export type indexProps = ProductDetailTabProps;

/** components / invoiceInfo / index：保留数据展示、编辑提交和父级事件回调。 */
export default function MigrationComponent(props: indexProps) {
    return (
        <ProductDetailTabSection title="发票明细" className="invoice-info">
            <ProductDetailTabMetrics items={[{ label: "已开票总金额（元）", value: "--" }, { label: "已开票（笔）", value: "--" }]} />
            <ProductDetailTabTable
                ariaLabel="发票明细"
                columns={emptyProductDetailColumns(["开票编号", "订单编号", "购买方", "发票金额（元）", "开票时间", "状态", "操作"])}
                data={props.items}
            />
            {props.children}
        </ProductDetailTabSection>
    );
}
